import React, { Component } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import banner from './images/banner.png';
import heart from './images/heart.png';
import iphone from './images/iphone.png';
import like from './images/like.png';
import profile from './images/profile.png';
import './css/Landing.css';

class Landing extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <div className="banner">
          <img src={banner} alt="Try something new" />
        </div>
        <div className="App-content">
          <div className="separator"></div>
          
          <div className="info">
            <p>Challenge your friends to try something new...Your
            participation generates money for charities around 
            the world!</p>

            <p>See trending challenges nearby via GPS and 
            discover hidden things in your city.</p>

            <p>SnapChallenge is a platform that turns 
            self-improvement, to-do lists, and city discovery 
            into a game, where you can earn money for 
            yourself and charities at the same time, then put it
            on the line to challenge others.</p>

            <p>SnapChallenge creates a social currency where 
            you can see what your friends want to accomplish 
            and add funds to award upon completion, crowd funding life experiences!</p>

            <p>WE CHALLENGE YOU TO TRY IT TODAY!</p>
          </div>

          <div className="separator"></div>

          <div className="iphone">
            <img src={iphone} alt="iphone" />
          </div>

          <div className="separator"></div>

          <div className="howto">
            <p>HOW <span className="orange">SNAP</span>CHALLENGE WORKS</p>
            <div className="grey-bar"></div>

            <div id="first" className="howto-head">
              <table width="100%">
                <tbody>
                  <tr>
                    <td><img src={profile} alt="You" /></td>
                    <td><span className="orange">YOU</span>PARTICIPATE</td>
                  </tr>
                </tbody>
              </table>
              <div className="grey-bar"></div>
              <table width="100%">
                <tbody>
                  <tr>
                    <td></td>
                    <td>WATCH OTHER USERS COMPLETE THEIR CHALLENGES.</td>
                  </tr>
                </tbody>
              </table>
              <div className="grey-bar"></div>
              <table width="100%">
                <tbody>
                  <tr>
                    <td></td>
                    <td>ACCEPT CHALLENGES AND COMPLETE IT YOURSELF.</td>
                  </tr>
                </tbody>
              </table>
              <div className="grey-bar"></div>
              <table width="100%">
                <tbody>
                  <tr>
                    <td></td>
                    <td>SPONSOR A CELEBRITY OR CHALLENGE A FRIEND TO JOIN IN THE FUN.</td>
                  </tr>
                </tbody>
              </table>
              <div className="grey-bar"></div>
            </div>

            <div id="second" className="howto-head">
              <table width="100%">
                <tbody>
                  <tr>
                    <td><img src={like} alt="Participation" /></td>
                    <td><span className="orange">YOUR</span>PARTICIPATION</td>
                  </tr>
                </tbody>
              </table>
              <div className="grey-bar"></div>
              <table width="100%">
                <tbody>
                  <tr>
                    <td></td>
                    <td>USING OUR APP GENERATES MONEY FOR CHARITIES <span className="grey-text">(PASSIVELY)</span>.</td>
                  </tr>
                </tbody>
              </table>
              <div className="grey-bar"></div>
              <table width="100%">
                <tbody>
                  <tr>
                    <td></td>
                    <td>THE MONEY YOU DONATE TO CHALLENGE A CELEBRITY OR FRIEND GOES DIRECTLY TO CHARITIES
                      <span className="grey-text"> (SOME GOES TO SNAPCHALLENGE... BUT WE PUT MOST OF IT
                      BACK IN TO GROW MORE CHALLENGES OR DONATE IT)</span></td>
                  </tr>
                </tbody>
              </table>
              <div className="grey-bar"></div>
            </div>

            <div id="third" className="howto-head">
              <table width="100%">
                <tbody>
                  <tr>
                    <td><img src={heart} alt="Heart" /></td>
                    <td><span className="orange">YOU</span>CHOOSE</td>
                  </tr>
                </tbody>
              </table>
              <div className="grey-bar"></div>
              <table width="100%">
                <tbody>
                  <tr>
                    <td></td>
                    <td>WHICH CHARITY GETS THE MONEY YOU RAISE! <span className="grey-text">(UNLESS OTHERWISE SPECIFIED)</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="separator"></div>

        </div>

        <Footer />

      </div>
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/Landing.js